module.exports = __webpack_public_path__ + "img/softlayer.d474be09.svg";